import actions from "./actions";
import { state, mutations, getters } from "./mutations";

export default { actions, state, mutations, getters };
